import type { NoteKind } from '../../../../api/venue-marketing';
import { plural } from '../../../../utils/counts';
import { openTasksLabel } from '../open-tasks';

import type { NoteList } from './use-marketing-notes';

/** An action item is called a task wherever a person reads it. */
export const NOTE_KIND_LABELS: Record<NoteKind, string> = {
  RD_NOTE: 'RD note',
  MARKETING_NOTE: 'Marketing note',
  ACTION_ITEM: 'Task',
};

export const NOTE_KIND_CLASSES: Record<NoteKind, string> = {
  RD_NOTE: 'nb-status-ontrack',
  MARKETING_NOTE: 'nb-status-open',
  ACTION_ITEM: 'nb-status-soft',
};

/** The id of the open tasks list, so a link from the venue banner can land on it. */
export const ACTION_ITEMS_ANCHOR = 'action-items';

export interface NoteListCopy {
  title: string;
  /** The heading count in words, for assistive tech: "1 note", "2 notes". */
  countLabel: (count: number) => string;
  addLabel: string;
  composerLabel: string;
  placeholder: string;
  /** Shown when the list is empty. The second part is only for someone who can add. */
  empty: string;
  emptyForEditors?: string;
}

export const NOTE_LIST_COPY: Record<NoteList, NoteListCopy> = {
  open: {
    title: 'Open tasks',
    countLabel: openTasksLabel,
    addLabel: 'Add',
    composerLabel: 'New task',
    placeholder: 'What needs doing?',
    empty: 'No open tasks.',
  },
  history: {
    title: 'Notes',
    countLabel: (n) => plural(n, 'note', 'notes'),
    addLabel: 'Add note',
    composerLabel: 'New note',
    placeholder: 'What do you know about this partnership?',
    empty: 'No notes yet.',
    emptyForEditors: 'Start the record. Even "intro email sent" helps the next person.',
  },
};

/** The kinds a person can pick when adding to a list, in the order offered. */
export function composerKinds(list: NoteList, canEditMarketingOnly: boolean): NoteKind[] {
  if (list === 'open') return ['ACTION_ITEM'];
  return canEditMarketingOnly ? ['MARKETING_NOTE', 'RD_NOTE'] : ['RD_NOTE', 'MARKETING_NOTE'];
}
